import React from 'react';
import { Box, Container, Typography, IconButton } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import logo from '../../../../assets/logo.png';

interface SurveyInstanceLayoutProps {
  children: React.ReactNode;
  title?: string;
  showBackButton?: boolean;
}

export const SurveyInstanceLayout: React.FC<SurveyInstanceLayoutProps> = ({
  children,
  title = 'Survey Instance',
  showBackButton = true,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/app/surveys');
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        minHeight: '100vh',
        minWidth: '100vw',
        bgcolor: 'background.default',
        py: 2, // Less vertical padding
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Container maxWidth={false} disableGutters sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {' '}
        {/* Changed to lg for wider display */}
        <Box
          sx={{
            position: 'relative',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Top bar with back button and logo */}
          <Box
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}
          >
            {/* Back button */}
            {showBackButton && (
              <IconButton
                onClick={handleBack}
                sx={{
                  color: 'text.secondary',
                }}
              >
                <ArrowBackIcon />
              </IconButton>
            )}

            {/* Logo and title */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box
                component="img"
                src={logo}
                alt="Lecturo Logo"
                sx={{
                  maxWidth: 32,
                  maxHeight: 32,
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 'bold',
                  color: 'text.primary',
                  fontSize: '1.1rem',
                }}
              >
                Lecturo
              </Typography>
            </Box>
          </Box>

          {/* Header */}
          <Box sx={{ mb: 2, textAlign: 'center' }}>
            {' '}
            {/* Less margin */}
            <Typography
              variant="h5" // Smaller header to save space
              component="h1"
              sx={{
                fontWeight: 'bold',
                color: 'text.primary',
                mb: 1,
              }}
            >
              {title}
            </Typography>
          </Box>

          {/* Main content */}
          <Box sx={{ flexGrow: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            {children}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
